exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-impressum-de-tsx": () => import("./../../../src/pages/impressum.de.tsx" /* webpackChunkName: "component---src-pages-impressum-de-tsx" */),
  "component---src-pages-impressum-en-tsx": () => import("./../../../src/pages/impressum.en.tsx" /* webpackChunkName: "component---src-pages-impressum-en-tsx" */),
  "component---src-pages-index-de-tsx": () => import("./../../../src/pages/index.de.tsx" /* webpackChunkName: "component---src-pages-index-de-tsx" */),
  "component---src-pages-index-en-tsx": () => import("./../../../src/pages/index.en.tsx" /* webpackChunkName: "component---src-pages-index-en-tsx" */)
}

